import { ObGrid } from '@outbound-ai/ursa'
import moment from 'moment'
import { useEffect, useState } from 'react'
import { FaStar } from 'react-icons/fa'
import styled from 'styled-components'
import { formatPhoneNumber } from 'utils/formatter'

interface IProps {
  details: any
  type: string
}

export const ClaimEntityVersionTable = ({ details, type }: IProps) => {
  const ENTITY_HISTORY_TABLE_COLUMNS = [
    {
      headerName: 'Current',
      field: 'current',
      cellRenderer: (params: any) => (params.value ? <FaStar /> : ''),
      width: 100,
      cellStyle: { color: 'rgb(25, 96, 147)' },
    },
    {
      headerName: 'Value',
      field: 'entityValue',
      cellRenderer: (params: any) => {
        if (type === 'Phone') {
          return formatPhoneNumber(params.value)
        } else if (type === 'decimal') {
          return <span title={formatter.format(params.value)}>{formatter.format(params.value)}</span>
        } else if (type === 'dateonly') {
          return moment(params.value).format('MM/DD/YYYY')
        } else {
          return params.value
        }
      },
      flex: 1,
      minWidth: 150,
      cellStyle: { width: '200px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' },
    },
    {
      headerName: 'Added on',
      field: 'dateCreated',
      valueFormatter: (params: any) =>
        new Date(params.value).toLocaleString('en-US', {
          month: 'short',
          day: 'numeric',
          year: 'numeric',
          hour: 'numeric',
          minute: '2-digit',
          hour12: true,
        }),
      flex: 1,
    },
    {
      headerName: 'Generated by',
      field: 'actorName',
      flex: 1,
    },
    {
      headerName: 'Comments',
      field: 'remarks',
      flex: 1,
    },
  ]

  const [gridApi, setGridApi] = useState<any>()

  const onGridReady = (params: any): Promise<void> => {
    params.api.sizeColumnsToFit()
    setGridApi(params)
    return Promise.resolve()
  }

  useEffect(() => {
    if (gridApi && details) {
      setTimeout(() => {
        gridApi.api.sizeColumnsToFit()
      }, 1000)
    }
  }, [details, gridApi])

  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  })
  return (
    <Div>
      <ObGrid
        reactiveCustomComponents={true}
        rowData={details}
        onGridReady={onGridReady as any}
        defaultColDef={DEFAULT_COLUMN as any}
        columnDefs={ENTITY_HISTORY_TABLE_COLUMNS as any}
        rowHeight={50}
        pagination={false}
      />
    </Div>
  )
}

const Div = styled.div`
  height: 15rem;
`
export const DEFAULT_COLUMN = {
  suppressMovable: true,
  sizeColumnsToFit: true,
  autoSizeColumn: true,
  autoHeight: true,
  wrapText: true,
  resizable: true,
}
